













import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";

import QrCodeLabelGeneratorDialog from "./QrCodeLabelGeneratorDialog.vue";

import { ILabelGeneratorGenericConfiguration } from "sitewhere-configuration-model";

@Component({
  components: {
    QrCodeLabelGeneratorDialog
  }
})
export default class QrCodeLabelGeneratorCreateDialog extends Vue {
  @Prop() readonly tenantId!: string;
  @Ref() readonly dialog!: QrCodeLabelGeneratorDialog;

  idsInUse: string[] = [];

  /** Emit payload */
  onPayload(payload: ILabelGeneratorGenericConfiguration): void {
    this.dialog.closeDialog();
    this.$emit("create", payload);
  }

  /** Open dialog */
  openDialog(idsInUse: string[]): void {
    this.idsInUse = idsInUse;
    this.dialog.reset();
    this.dialog.openDialog();
  }
}
